import YesNoModel from 'functions/YesNoModel';
import ScreeningInfoModal from 'functions/ScreeningInfoModal';
import { holidayChk, reloadCtrlCfg, showRstdCcyMsgDialogIfNeeded, translateFormMsg } from './wuiUtils';
import { post } from "mdui/api/HttpReq";
import { t } from "i18next";
import { AlertType } from 'mdui/page/MsgBox';

const resubmitClrData = async ({ props, formData, updateState, config, setCfg, values, ...data }) => {
    const cleanedValues = Object.fromEntries(
        Object.entries(values).filter(([key]) => !key.startsWith("actChk"))
    );

    return cleanedValues;
}

const blkSubmitDialogResubmit = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data }) => {
    const action = props.field && props.field.name ? props.field.name : '';

    let labels = {
        title: "Confirm",
        description: `Are you sure you want to ${action} the transactions?`
    }
    let cancel = {};
    const module = props.field?.module || formData?.module || modNm;
    let actionValidate = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = config.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: actionValidate, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK });
    if (handleApiError(val, { module, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };
    if (action === 'reject' && nFormData?.txStts === 'FAILED') {
        const message = translateFormMsg('confirmFailedMsg', nFormData, module);
        const title = translateFormMsg('confirmMsgTitle', nFormData, module);
        showCustomModal({
            content: (
                <YesNoModel message={message}
                    onYes={() => {
                        hideCustomModal?.();
                        submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                    }}
                    onNo={() => { hideCustomModal?.(); }}
                />
            ),
            width: '520px',
            title: title,
        });
        return;
    }
    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}

const blkSubmitDialog = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data }) => {
    const action = props.field && props.field.name ? props.field.name : '';

    let labels = {
        title: "Outward Payment File Confirmation",
        description: `Are you sure you want to ${action} the Outward Payment File ${formData.fileNm}?`
    }
    let cancel = {};
    const module = props.field?.module || formData?.module || modNm;
    let actionValidate = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = config.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: actionValidate, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK });
    if (handleApiError(val, { module, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };
    if (action === 'reject' && nFormData?.txStts === 'FAILED') {
        const message = translateFormMsg('confirmFailedMsg', nFormData, module);
        const title = translateFormMsg('confirmMsgTitle', nFormData, module);
        showCustomModal({
            content: (
                <YesNoModel message={message}
                    onYes={() => {
                        hideCustomModal?.();
                        submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                    }}
                    onNo={() => { hideCustomModal?.(); }}
                />
            ),
            width: '520px',
            title: title,
        });
        return;
    }
    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}

const showBlkSummary = async ({ props, config, mtype, formData, handleApiError, changeView, navigate, updateState, validate, showDialog, activeTab, ...data }) => {

    let nAttr = data?.attr || {};
    nAttr = {
        ...nAttr,
        txnSumSect: { hide: true },   // hide entire summary fields group
        txnSumtable: { hide: false },
        txnSumTbl: { hide: false }    // show the table
    };
    changeView({ props, formData, updateState, validate, showDialog, activeTab, viewName: 'cnfmTabs', ...data, attr: nAttr });
}
const blkHolidayChk = async ({ props, changeView, formData, activeTab, updateState, ...data }) => {
    let nattr = { ...data.attr }
    if (formData.ccy !== "") {

        const payload = {
            productMode: formData.productMode ?? "BT",
            txCd: formData.trxnCd,
            valueDt: formData.valueDt,
            debitCcy: formData.ccy,
            creditCcy: formData.creditCcy,
        };
        let val = await post('holiday', 'holiday-chk', payload);

        if (val.localholiday && val.localholiday === "Y") {
            let newMsg = { key: t("holiday_msg"), type: AlertType.W };
            let attributes = nattr["ccy"] || {}
            delete attributes['err'];
            nattr["ccy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["create"] = { disabled: true }
            updateState({ newFormData: formData, newMsg, newAttr: nattr })
            return true;
        } else if (val.debitHoliday && val.debitHoliday === "Y") {
            let newMsg = { key: t("ccy_holiday_msg"), type: AlertType.W };
            let attributes = nattr["ccy"] || {}
            delete attributes['err'];
            nattr["ccy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["debitCcy"] = { ...attributes, err: "debitCcy_holiday" };
            nattr["create"] = { disabled: true }
            updateState({ newFormData: formData, newMsg, newAttr: nattr })
            return true;
        } else if (val.creditHoliday && val.creditHoliday === "Y") {
            let newMsg = { key: t("ccy_holiday_msg"), type: AlertType.W };
            let attributes = nattr["creditCcy"] || {}
            delete attributes['err'];
            nattr["creditCcy"] = { ...attributes, err: "creditCcy_holiday" };
            updateState({ newFormData: formData, newMsg, newAttr: nattr })
            return true;
        }

    }
    const clearErr = (nattr, ...fields) => {
        fields.forEach(field => {
            const { err, ...rest } = nattr[field] || {};
            nattr[field] = rest;
        });
    };
    clearErr(nattr, 'ccy', 'creditCcy');
    nattr["create"] = { disabled: false };
    nattr["submit"] = { disabled: false };
    updateState({ newFormData: formData, newAttr: nattr });
    return false;
}


const blkBack = async ({ props, changeView, formData, activeTab, updateState, ...data }) => {
    let storedAttr = data.attr || {};
    storedAttr = {
        ...storedAttr,
        txnSumSect: { ...storedAttr.txnSumSect, hide: false },       // hide entire summary fields group
        txnSumtable: { ...storedAttr.txnSumtable, hide: true },
        txnSumTbl: { ...storedAttr.txnSumTbl, hide: true },
        'Upload File': { ...storedAttr['Upload File'], hide: false },
        "Tab-1": { ...storedAttr["Tab-1"], hide: false },
        "upldPymtFileTab": {
            ...storedAttr.upldPymtFileTab,
            hide: false
        }   // show the table
    };
    let newFormData = {
        ...formData,
        createBtnFlag: true
    };
    changeView({ props, formData: newFormData, updateState, viewName: 'pageConfig', activeTab, ...data, attr: storedAttr });
}
const blkSubmitDialogMkr = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, ...data }) => {
    const btnAction = props.field && props.field.name ? props.field.name : '';
    const module = props.field?.module || formData?.module || modNm;

    let action = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = config.initPK || '';

    let isCrtTab = activeTab===0
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };

    let labels = {
        title: "Outward Payment File Confirmation",
        description: `Are you sure you want to ${btnAction} the Outward Payment File ${formData.fileNm}?`
    }
    let storedAttr = data.attr || {};
    storedAttr = {
        ...storedAttr,
        'Upload File': { ...storedAttr['Upload File'], hide: true },
        "Tab-1": { ...storedAttr["Tab-1"], hide: !isCrtTab },
        "upldPymtFileTab": { ...storedAttr.upldPymtFileTab, hide: isCrtTab }
    };
    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    showBlkSummary({ props, formData: nFormData, updateState, validate, showDialog, config, handleApiError, changeView, navigate, modNm, mtype, activeTab, submitConfirm, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, ...data, attr: storedAttr });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}

const blkInstSubmit = async ({ props, back, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, postForm, ...data }) => {

    let rslt = await postForm({ props, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
    if (handleApiError(rslt, { ...data, module: props.field.module, updateState })) {
        return;
    }
    await back({ props, formData, updateState, responseData: rslt, ...data });
    return;
}
const blkInstSubmitConfirm = async ({
    props,
    formData,
    showCustomModal,
    hideCustomModal,
    config,
    navigate,
    mtype,
    handleApiError,
    updateState,


    ...data
}) => {

    let action = config.pages[config.cPKey].action || 'summary';
    console.log("pages", config.pages);
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = formData.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };


    if (showRstdCcyMsgDialogIfNeeded({
        nFormData,
        module,
        updateState,
        showCustomModal,
        hideCustomModal,
        formData,
        attr: data.attr,
        onContinue: blkInstSubmit,
})) {

        return;
}else{

    await blkInstSubmit({
        props,
        formData,
        showCustomModal,
        hideCustomModal,
        config,
        navigate,
        mtype,
        handleApiError,
        updateState,
        ...data}
    );
}

};



const rtOHSubmitDialogMkrDecline = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, ...data }) => {
    const btnAction = props.field && props.field.name ? props.field.name : '';
    const module = props.field?.module || formData?.module || modNm;

    let action = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = formData.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };
    let description = props.field.name === 'submit' ? `Are you sure you want to release the on-hold transactions?` : `Are you sure you want to decline the On Hold Transaction?`;

    let labels = {
        title: "Confirm",
        description: description
    }

    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}

const rtOHTrxnSave = async ({ props, formData, submitConfirm, back, updateState, ...data }) => {
    var rslt = await submitConfirm({ props, formData, updateState, ...data });
    if (rslt) {
        await back({ props, formData, updateState, responseData: rslt, ...data });
    }
}
const onHoldCalcBt = async ({ props, formData, updateState, ...data }) => {
    console.log("print onHoldCalc", formData);
    const val = await post('fee-cal', 'list', { ...formData, module: props.field.moduleId })
    const { locEqAmt: cnvtdAmt, netPymtAmt: netPaymentAmt, netLocEqAmt: actlFlatCnvdAmt, ...rest } = val;
    const newFormData = {
        ...formData,
        ...rest,
        cnvtdAmt,
        netPaymentAmt,
        actlFlatCnvdAmt
    }
    updateState({ newFormData: newFormData });
}
const onHoldCalc = async ({ props, formData, updateState, ...data }) => {
    console.log("print onHoldCalc", formData);
    const val = await post('fee-cal', 'list', { ...formData, module: props.field.moduleId })
    const newFormData = {
        ...formData,
        ...val
    }
    updateState({ newFormData: newFormData });
}

const rtOHSubmitDialogCkr = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, ...data }) => {
    const btnAction = props.field && props.field.name ? props.field.name : '';
    const module = props.field?.module || formData?.module || modNm;

    let action = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = formData.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };
    let description = props.field.name === 'approve' ? `Are you sure want to Approve the Request?` : `Are you sure want to Reject the Request?`;

    let labels = {
        title: "Confirm",
        description: description
    }

    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}

const blkSubmitDialogMkrDecline = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, changeView, navigate, activeTab, ...data }) => {
    const btnAction = props.field && props.field.name ? props.field.name : '';
    const module = props.field?.module || formData?.module || modNm;

    let action = config.pages[config.cPKey].action || 'summary';
    let modPK = config.pages[config.cPKey].modPK || '';
    let parentPK = formData.parentPK || '';
    let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: action, ...formData, mtype: mtype, wuiFldProps: { field: props.field }, modPK: modPK, parentPK: parentPK }, navigate);
    if (handleApiError(val, { ...data, module: props.field.module, updateState })) {
        return;
    }
    let table = { ...formData.table, ...val.table }
    let nFormData = { ...formData, ...val, table: { ...table } };

    let labels = {
        title: "Outward Payment File Confirmation",
        description: `Are you sure you want to decline this Payment File:  ${formData.fileNm}?`
    }

    showCustomModal({
        content: (
            <YesNoModel message={labels.description}
                onYes={() => {
                    hideCustomModal?.();
                    submitConfirm({ props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data });
                }}
                onNo={() => { hideCustomModal?.(); }}
            />
        ),
        width: '520px',
        title: labels.title,
    });
}
const cntryCdChng = async ({ props, formData, updateState, ...data }) => {
    let newFormData = {
        ...formData,
    };

    // Debtor
    if(props.field.name==="dbtrBnkCntrycd"){
    if (formData.dbtrBnkCntrycd === 'SG') {
            newFormData.dbtrTwnNm = 'Singapore';
    } else {
        newFormData.dbtrTwnNm = '';
    }
}

    if(props.field.name==="cdtrCntryCd"){
    if (formData.cdtrCntryCd === 'SG') {
            newFormData.cdtrTwnNm = 'Singapore';
    } else {
        newFormData.cdtrTwnNm = '';
    }
}

    updateState({ newFormData });
};

const clearInstrForm = ({ props, formData, updateState, ...data }) => {
    const clearFlds = [
        "chnlMiscData", "creditAmt", "creditCcy", "dbtrCntct", "cdtrRsdntStts",
        "chrgAmts", "chrgAmtsLcl", "acctToBic", "acctTo", "cdtrName",
        "actlFlatCnvdAmtWithCcy", "addnlInfo1", "cdtrAddr", "cdtrAddr1",
        "cdtrAddr2", "cdtrAddr3", "cdtrBnkAddr1", "cdtrBnkAddr2",
        "cdtrBnkAddr3", "cdtrCntryCd", "cdtrTwnNm",
        "senderRcvrInfo", "adnlSndToRecvInfo", "fxRtDt", "recvCorrPrefSSI",
        "chrgBr", "commH", "cableFee", "debtFeeLbl", "stdFeeLbl",
        "credFeeLbl", "commIL", "agntFee", "cdtAgntFee",
        "rssiRspnData", "othrPymtDtl", "pymtPurpcd", "sndrCorrBic", "xchgRate", "locEqAmt", "netRemitAmt"
    ];

    const clearFldsMultiple = [
        "chnlMiscData", "creditAmt", "creditCcy", "dbtrCntct", "cdtrRsdntStts",
        "chrgAmts", "chrgAmtsLcl", "acctToBic", "acctTo", "cdtrName",
        "actlFlatCnvdAmtWithCcy", "addnlInfo1", "cdtrAddr", "cdtrAddr1",
        "cdtrAddr2", "cdtrAddr3", "cdtrBnkAddr1", "cdtrBnkAddr2",
        "cdtrBnkAddr3", "cdtrCntryCd", "cdtrTwnNm",
        "senderRcvrInfo", "adnlSndToRecvInfo", "fxRtDt", "recvCorrPrefSSI",
        "chrgBr", "commH", "cableFee", "debtFeeLbl", "stdFeeLbl",
        "credFeeLbl", "commIL", "agntFee", "cdtAgntFee",
        "rssiRspnData", "othrPymtDtl", "pymtPurpcd",
        "dbtrName", "sndrCorrBic", "acctFr", "acctFrType", "debitCcy", "idType", "idNo", "dbtrRsdntStts", "dbtrCifid",
        "dbtrPostcd", "dbtrAddr1", "dbtrAddr2", "dbtrAddr3",
        "dbtrBnkCntrycd", "dbtrTwnNm", "xchgRate", "locEqAmt", "netRemitAmt"
    ];

    const fieldsToClear =
        formData.batchDbtType === "M" ? clearFldsMultiple : clearFlds;

    fieldsToClear.forEach(fld => {
        formData[fld] = "";
    });

    updateState({ newFormData: formData });
};

const reloadMISel = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    let { chnlInd, ...restData } = { ...formData }
    if (formData.marketInfra && formData.marketInfra != '') {
        let nchnlInd = formData.marketInfra === 'CB' ? 'BATCH_FILE_STATUS_CB' : 'BATCH_FILE_STATUS_G3';
        let newFormData = { ...restData, chnlInd: nchnlInd }
        await reloadCtrlCfg({ props, formData: newFormData, ctrlCfg, config, updateState, ...args });
        return;
    }
    await reloadCtrlCfg({ props, formData: restData, ctrlCfg, config, updateState, ...args });
}
const reloadChnlIndSel = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
    let { chnlInd, ...restData } = { ...formData }
    if (formData.rqstChnl && formData.rqstChnl != '') {
        let nchnlInd = formData.rqstChnl === 'BPRTBFST' ? 'RTBFST_TXN' : (formData.rqstChnl === 'RTG3H' ? 'G3_TXN' : chnlInd);
        let newFormData = { ...restData, chnlInd: nchnlInd }
        await reloadCtrlCfg({ props, formData: newFormData, ctrlCfg, config, updateState, ...args });
        return;
    }
    await reloadCtrlCfg({ props, formData: restData, ctrlCfg, config, updateState, ...args });
}

const showScreeningInfo = async ({ props, formData, ctrlCfg, config, updateState, showCustomModal, hideCustomModal, ...args }) => {
    const raw = props?.row?.scrngResultRaw;
    const typ = props?.row?.scrngSvc;
    showCustomModal({
        content: (
            <ScreeningInfoModal data={raw}
                onOk={() => { hideCustomModal?.(); }}
            />
        ),
        title: `${typ} Screening Result`,
        width: '700px',
    });
}

const blkTabChng = async ({ props, reload, formData, ctrlCfg, config, updateState, showCustomModal, hideCustomModal, ...args }) => {
    let fKey = config.pages[config.cPKey]?.config.fKey;
    if (fKey !== 'cnfmTabs') {
        if (reload) {
            let tabNm = props?.field?.tabNm;
            let newFormData = {md_page_title_key: tabNm === 'upldPymtFileTab'?'pg_title_upload': 'pg_title_add'}
           await reload({formData, newFormData});
        }
    }
   
    return true;
}

const backToCreate = async ({ props, create, formData, ctrlCfg, config, updateState, showCustomModal, hideCustomModal, ...args }) => {
    const matchingKey = Object.keys(config.pages).find(key => key.toLowerCase().endsWith('search'));
   await create({ props, create, prevPage: matchingKey, formData, ctrlCfg, config, updateState, showCustomModal, hideCustomModal, ...args });
}

const reSubmitBlkMI = async ({ props, formData, directSubmit, ...args }) => {
    await directSubmit({ props, formData, directSubmit, ...args });
}

export { reSubmitBlkMI, backToCreate, blkTabChng, showScreeningInfo, resubmitClrData, reloadMISel, onHoldCalcBt, onHoldCalc, rtOHTrxnSave, rtOHSubmitDialogCkr, blkSubmitDialog, showBlkSummary, rtOHSubmitDialogMkrDecline, blkBack, blkSubmitDialogMkr, blkSubmitDialogMkrDecline, cntryCdChng, blkHolidayChk, blkInstSubmit, clearInstrForm, blkInstSubmitConfirm,blkSubmitDialogResubmit,reloadChnlIndSel }